var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDlpHighlight = function SvgDlpHighlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C29B40",
    d: "m130.393 2.508-1.358 2.646-83.688.085c-32.803.085-35.754.102-36.392.373-1.56.628-2.75 1.68-3.404 2.986-.52 1.068-.906 2.409-3.035 10.635-.302 1.12-.973 3.75-1.527 5.853L0 28.902l.335 1.103c.37 1.204 1.057 2.222 1.325 1.95.084-.101.755-1.356 1.493-2.798l1.358-2.63 34.85-.084c33.607-.085 82.882-.102 83.67-.407 1.426-.56 2.331-1.17 3.505-2.358 1.509-1.51 2.029-2.663 3.136-6.989.47-1.866 1.006-3.884 1.174-4.495.168-.61.738-2.748 1.258-4.75.855-3.257.956-3.783.872-4.834-.084-1.255-.47-2.273-.939-2.579-.235-.152-.47.187-1.644 2.477"
  })));
};
export default SvgDlpHighlight;